import { ShieldCheck, Clock, MessageCircle, Phone } from "lucide-react";
import SEO from "@/components/SEO";
import QuoteForm from "@/components/QuoteForm";
import { FadeUp, MaskLine } from "@/components/motion";
import { CONTACT, WHATSAPP_DEFAULT } from "@/data/content";

export default function Quote() {
  return (
    <main className="bg-slate-50 pt-20">
      <SEO
        title="Get a Free Moving Quote"
        description="Get a free instant moving quote from NextMove Removalists. Transparent pricing, no hidden costs. Servicing Sydney, Melbourne, Brisbane & Australia-wide."
        path="/quote"
      />
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-8 py-16 sm:py-24 lg:grid-cols-[1fr_1.4fr]">
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.22em] font-semibold text-amber-600">Free · Itemised · In writing</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-black tracking-tight leading-[1.08] text-navy">
            <MaskLine delay={0.1}>Your written quote</MaskLine>
            <MaskLine delay={0.22}>starts <span className="text-amber-500">here.</span></MaskLine>
          </h1>
          <FadeUp delay={0.4}>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-600">
              Fill this in and it lands straight in our quoting team's inbox. We reply with an
              itemised, fixed quote, usually within the hour, {CONTACT.hours}.
            </p>
          </FadeUp>
          <FadeUp delay={0.55} className="mt-10 space-y-5">
            <div className="flex items-start gap-3">
              <ShieldCheck className="mt-0.5 h-5 w-5 text-amber-500" />
              <p className="text-sm text-slate-600"><strong className="text-navy">Itemised written quotes.</strong> Stairs, access and heavy items are priced upfront in your quote, no day-of ambush.</p>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="mt-0.5 h-5 w-5 text-amber-500" />
              <p className="text-sm text-slate-600"><strong className="text-navy">Fast turnaround.</strong> Quotes in under an hour during operating hours, seven days a week.</p>
            </div>
            <div className="flex items-start gap-3">
              <MessageCircle className="mt-0.5 h-5 w-5 text-amber-500" />
              <p className="text-sm text-slate-600">
                <strong className="text-navy">Prefer to chat?</strong>{" "}
                <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="quote-page-whatsapp" className="font-bold text-[#128C7E] underline">WhatsApp us</a>
                {" "}or call{" "}
                <a href={`tel:${CONTACT.phonePrimaryRaw}`} data-testid="quote-page-call" className="font-bold text-navy underline">{CONTACT.phonePrimary}</a>.
              </p>
            </div>
          </FadeUp>
          <FadeUp delay={0.7} className="mt-10 rounded-2xl border border-slate-200 bg-white p-6">
            <p className="text-xs font-mono uppercase tracking-widest text-slate-400">Direct lines</p>
            <a href={`tel:${CONTACT.phonePrimaryRaw}`} data-testid="quote-side-phone-1" className="mt-2 flex items-center gap-2 font-display text-lg font-bold text-navy hover:text-amber-600 transition-colors">
              <Phone className="h-4 w-4 text-amber-500" /> {CONTACT.phonePrimary}
            </a>
            <a href={`tel:${CONTACT.phoneMobileRaw}`} data-testid="quote-side-phone-2" className="mt-1 flex items-center gap-2 font-display text-lg font-bold text-navy hover:text-amber-600 transition-colors">
              <Phone className="h-4 w-4 text-amber-500" /> {CONTACT.phoneMobile}
            </a>
          </FadeUp>
        </div>
        <FadeUp delay={0.3}>
          <QuoteForm />
        </FadeUp>
      </div>
    </main>
  );
}
